'use strict';

var BrowserExporter = require('../../exporters/browser');

module.exports = function () {
  return BrowserExporter;
};